module.exports = __webpack_public_path__ + "static/media/0340_Small.471b2483.jpg";